"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useCombinedRefs(...refs) {
    const targetRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        refs.forEach(ref => {
            if (!ref)
                return;
            ref.current = targetRef.current;
        });
    }, refs); // eslint-disable-line react-hooks/exhaustive-deps
    return targetRef;
}
exports.default = useCombinedRefs;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWNvbWJpbmVkLXJlZnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL3V0aWxzL3VzZS1jb21iaW5lZC1yZWZzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQWlEO0FBRWpELFNBQXdCLGVBQWUsQ0FBSSxHQUFHLElBQXdDO0lBQ3BGLE1BQU0sU0FBUyxHQUFHLElBQUEsY0FBTSxFQUFJLElBQUksQ0FBQyxDQUFDO0lBRWxDLElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDYixJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFO1lBQ2pCLElBQUksQ0FBQyxHQUFHO2dCQUFFLE9BQU87WUFFakIsR0FBRyxDQUFDLE9BQU8sR0FBRyxTQUFTLENBQUMsT0FBTyxDQUFDO1FBQ2xDLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUMsa0RBQWtEO0lBRTVELE9BQU8sU0FBUyxDQUFDO0FBQ25CLENBQUM7QUFaRCxrQ0FZQyJ9